import * as React from 'react';
import PropTypes from 'prop-types';

const SvgNavigationStudentNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.214 9.048l-9.99-4.995a.5.5 0 00-.448 0l-10 5a.5.5 0 000 .894L5.5 11.81v4.666c0 .124.04.245.115.345 3.192 4.257 9.578 4.257 12.77 0 .075-.1.115-.22.115-.345V11.81l3-1.5V15a.5.5 0 001 0V9.5c0-.013 0-.027-.002-.04a.492.492 0 00-.284-.412zM17.5 12.309l-5.276 2.638a.5.5 0 01-.448 0L6.5 12.31v4.022c2.79 3.575 8.21 3.575 11 0V12.31zM3.118 9.5L12 5.059 20.882 9.5 12 13.941 3.118 9.5z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationStudentNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgNavigationStudentNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgNavigationStudentNormalSmall;
